// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { SelectionModelService } from '../components/article/service/selection-model.service';
import { CopyPasteAdditionalOperations } from '../components/article/manager/copy-paste-additional-operations';
import { ArticleLoadingManager } from '@article/service/article-loading.manager';
import { ReplaceLabelingArticleHelper } from '../components/label/replace-labeling-helper/replace-labeling-article.helper';

@Injectable({providedIn: 'root'})
export class ClearService {
  private _undoRedoHelper: UndoRedoHelper;
  private _selectionModelService: SelectionModelService;
  private _copyPasteAdditionalOperations: CopyPasteAdditionalOperations;
  private initialized = false;
  private _articleLoadingManager: ArticleLoadingManager;
  private _replaceLabelingArticleHelper: ReplaceLabelingArticleHelper;

  /**
   * Clears additional managers (e.g. to which handles undo/redo stack) related to the current project.
   * It should be called when current project needs to be reset/cleared.
   */
  public clearManagers(): void {
    this.ensureInitialized();
    this._undoRedoHelper.clearAll();
    this._copyPasteAdditionalOperations.clear();
    this._selectionModelService.removeAllSelections();
    this._articleLoadingManager.clear();
  }

  public clearReplaceLabelingArticleHelper() {
    this.ensureInitialized();
    this._replaceLabelingArticleHelper.clear();
  }

  public initialize(undoRedoHelper: UndoRedoHelper,
                    selectionModelService: SelectionModelService,
                    copyPasteAdditionalOperations: CopyPasteAdditionalOperations,
                    articleLoadingManager: ArticleLoadingManager,
                    replaceLabelingArticleHelper: ReplaceLabelingArticleHelper,
                    ) {
    this._undoRedoHelper = undoRedoHelper;
    this._selectionModelService = selectionModelService;
    this._copyPasteAdditionalOperations = copyPasteAdditionalOperations;
    this._articleLoadingManager = articleLoadingManager;
    this._replaceLabelingArticleHelper = replaceLabelingArticleHelper;
    this.initialized = true;
  }

  private ensureInitialized() {
    if (!this.initialized) {
      throw new Error("ClearService not initialized!")
    }
  }
}

